import React from 'react'
import { Camp as BaseCamp } from '../../types'
import { SessionsBanner } from '../SessionsBanner'

interface Camp extends BaseCamp {
  totalDurationDays?: number
  projectsOutputDescription?: string
}

export const CampPointers = ({ camp }: { camp: Camp }) => (
  <div className='uncontainer'>
    <SessionsBanner outputDescription={camp.projectsOutputDescription ?? ''} />
  </div>
)
